import styled, { css } from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import {
    INSIGHTS_LOADING_MOTION_OPACITY_MS,
    INSIGHTS_LOADING_MOTION_TRANSFORM_MS,
} from "./insightsLoading.constants";
import { InsightsLoadingSlidePhase } from "./insightsLoading.types";

export const InsightsLoadingRotatingViewport = styled(Flex)`
    flex: 1;
    min-width: 0;
    min-height: 20px;
    position: relative;
    overflow: hidden;
    align-items: center;
`;

export const InsightsLoadingRotatingMotion = styled.div<{ $slide: InsightsLoadingSlidePhase }>`
    display: block;
    width: 100%;
    will-change: transform, opacity;
    transition:
        transform ${INSIGHTS_LOADING_MOTION_TRANSFORM_MS}ms cubic-bezier(0.4, 0, 0.2, 1),
        opacity ${INSIGHTS_LOADING_MOTION_OPACITY_MS}ms ease;
    ${({ $slide }) =>
        $slide === InsightsLoadingSlidePhase.Enter &&
        css`
            transform: translateY(-100%);
            opacity: 0;
        `}
    ${({ $slide }) =>
        $slide === InsightsLoadingSlidePhase.Idle &&
        css`
            transform: translateY(0);
            opacity: 1;
        `}
    ${({ $slide }) =>
        $slide === InsightsLoadingSlidePhase.Exit &&
        css`
            transform: translateY(-100%);
            opacity: 0;
        `}
`;
